module.exports = {"id":"191076","name":"Jóhann Berg Guðmundsson","rating":"78","photo":"./data/images/photos/3/191076.png","club":{"name":"Burnley","logo":"./data/images/clubs/Burnley.png"},"positions":["MD","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JohannBergGuðmundsson0.json
// module id = 2069
// module chunks = 0